/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Node_Onair_ValueInputs */

const en_fw_node_onair_value = /** @type {(inputs: Fw_Node_Onair_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fridays from Oct 9, 2026`)
};

const zh_fw_node_onair_value = /** @type {(inputs: Fw_Node_Onair_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2026 年 10 月 9 日起每周五`)
};

/**
* | output |
* | --- |
* | "Fridays from Oct 9, 2026" |
*
* @param {Fw_Node_Onair_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_node_onair_value = /** @type {((inputs?: Fw_Node_Onair_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Node_Onair_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_node_onair_value(inputs)
	return zh_fw_node_onair_value(inputs)
});
export { fw_node_onair_value as "fw.node.onair_value" }